<template>
    <div>
        <component v-for="(message, index) in messages" :key="index" :is="message.type + 'Message'" :message="message" :contact="contact"/>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

//message types
import AcceptedRentalRequestMessage from '@/components/inbox/messagesCard/AcceptedRentalRequestMessage.vue';
import CancelledRentalRequestMessage from '@/components/inbox/messagesCard/CancelledRentalRequestMessage.vue';
import DeclinedRentalRequestMessage from '@/components/inbox/messagesCard/DeclinedRentalRequestMessage.vue';
import InboundRentalRequestMessage from '@/components/inbox/messagesCard/InboundRentalRequestMessage.vue';
import InboundTextMessage from '@/components/inbox/messagesCard/InboundTextMessage.vue';
import OutboundRentalRequestMessage from '@/components/inbox/messagesCard/OutboundRentalRequestMessage.vue';
import OutboundTextMessage from '@/components/inbox/messagesCard/OutboundTextMessage.vue';
import ConfirmedMessage from '@/components/inbox/messagesCard/ConfirmedMessage.vue';
import NotificationMessage from '@/components/inbox/messagesCard/shared/NotificationMessage.vue';
import TooliabaTextMessage from '@/components/inbox/messagesCard/TooliabaTextMessage.vue';
import CancelledMessage from '@/components/inbox/messagesCard/CancelledMessage.vue';
import DeclineExplainationMessage from '@/components/inbox/messagesCard/DeclineExplainationMessage.vue';
import PaymentLinkMessage from '@/components/inbox/messagesCard/PaymentLinkMessage.vue';
import RatingMessage from '@/components/inbox/messagesCard/RatingMessage.vue';

export default {
    components: {
        AcceptedRentalRequestMessage,
        CancelledRentalRequestMessage,
        DeclinedRentalRequestMessage,
        InboundRentalRequestMessage,
        InboundTextMessage,
        OutboundRentalRequestMessage,
        OutboundTextMessage,
        ConfirmedMessage,
        NotificationMessage,
        TooliabaTextMessage,
        CancelledMessage,
        DeclineExplainationMessage,
        PaymentLinkMessage,
        RatingMessage
    },
    computed: {
        ...mapState('messages', ['messages']),
        ...mapGetters('messages', ['contact'])
    },
    methods: {
        ...mapActions('messages', ['markRead'])
    },
    watch: {
        messages() {
            this.markRead(this.contact.id);
        }
    },
    created: function() {
        this.markRead(this.contact.id);
    }
};
</script>
